// frontend/socket.js
import { io } from "socket.io-client";

export const socket = io("https://firetrace-capstone.onrender.com", {
  transports: ["websocket", "polling"],
});
